import React , {createContext , useReducer , useEffect} from 'react';
import AppReducer from "../../src/Context/AppReducer"


const initialState = {
  fav_movies : localStorage.getItem("fav_movies")?JSON.parse(localStorage.getItem("fav_movies")):[]
};

export const GlobalContext = createContext(initialState);

export const GlobalProvider = (props)=>{
  const [state, dispatch] = useReducer(AppReducer, initialState);

  useEffect(() => {
    localStorage.setItem("fav_movies", JSON.stringify(state.fav_movies));
  }, [state])

  const addmoviestofav  = (movie)=>{
    dispatch({type:"ADD_MOVIE_TO_FAV", payload: movie})
  };
  const removefromfav = (id) => {
    dispatch({ type: "REMOVE_MOVIE_FROM_FAV", payload: id });
  };

  return (
    <GlobalContext.Provider
      value={{
        fav_movies: state.fav_movies,
        addmoviestofav,
        removefromfav,
      }}
    >
      {props.children}
    </GlobalContext.Provider>
  );
};